import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/top-clip.html',
      name: 'Top Clip',
      component: () => import(/* webpackChunkName: "top-clip-view" */ '@/views/TopClipView.vue')
    },
    {
      path: '/broadcaster-choice',
      name: 'Broadcaster Choice',
      component: () => import(/* webpackChunkName: "broadcaster-choice-view" */ '@/views/BroadcasterChoiceView.vue')
    },
    {
      path: '/help',
      name: 'Help',
      component: () => import(/* webpackChunkName: "help-view" */ '@/views/Help.vue')
    },
    { path: '*', redirect: '/top-clip.html' }
  ]
})
